import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dtwin && _vm.dtwin.id ? _c('router-link', {
    attrs: {
      "to": _vm.cardLink
    }
  }, [_c(VCard, {
    staticClass: "mx-auto fav-dtwin-card grey-border",
    style: _vm.tileSizeSetting == 1 ? 'height: 482px; max-height: 482px;' : '',
    attrs: {
      "min-width": "240"
    }
  }, [_vm.showMap ? _c('core-dtwin-map-header-map', {
    staticStyle: {
      "width": "100%",
      "height": "185px"
    },
    attrs: {
      "geoCoordinates": _vm.dtwinCoordinates,
      "dtwTitle": _vm.dtwin.title,
      "dtwData": _vm.dtwin.data,
      "zoom": 14,
      "favorite": "",
      "animateFlyIn": false,
      "mapInteractive": false
    }
  }) : _c('div', {
    staticClass: "dtwin-detail-header pt-4",
    staticStyle: {
      "height": "185px"
    }
  }, [_c('h3', {
    staticClass: "ml-4 pl-3 pr-3 mt-8 dtwin-title-frame header-frame text-truncate"
  }, [_vm.dtwin.data.faIcon ? _c(VIcon, {
    class: _vm.color + '--text headline-icon',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.dtwin.data.faIcon}`)
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "data-cy": "fav_dtwin_card"
    }
  }, [_vm._v(_vm._s(_vm.dtwin.title))])], 1)]), _vm.twinDataStates.length ? _c('core-dtwin-state-preview-db-tiles', {
    staticClass: "fav-tiles mt-2",
    style: _vm.tileSizeSetting == 1 ? 'height: 282px; max-height: 282px;' : '',
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "tileSizeSetting": _vm.tileSizeSetting,
      "favCard": ""
    }
  }) : _c(VCardText, {
    class: `fav-tiles${_vm.dsize} pt-0 mt-2`
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.dtwin.data.description || ''
    }
  })], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };